<template>
  <div class="flex min-h-screen max-h-screen flex-col overflow-hidden bg-white">
    <Navbar v-if="userStore.user" />
    <BasicNavbar v-else show-cta />
    <AlertBanner v-if="userStore.user" root />
    <slot />
  </div>
</template>

<script setup lang="ts">
import Navbar from '@/shared/components/Navbar.vue'
import BasicNavbar from '@/shared/components/BasicNavbar.vue'
import AlertBanner from '@/shared/components/AlertBanner.vue'
import { useUserStore } from '@/shared/stores/user'

const userStore = useUserStore()
</script>
